import React, { Component } from "react";
import PropTypes from "prop-types";
import { Layer } from "recharts";

import styles from "./style.module.css";

export default class Demo extends Component {
  static displayName = "SankeyLinkDemo";

  static propTypes = {
    sourceX: PropTypes.number,
    targetX: PropTypes.number,
    sourceY: PropTypes.number,
    targetY: PropTypes.number,
    sourceControlX: PropTypes.number,
    targetControlX: PropTypes.number,
    sourceRelativeY: PropTypes.number,
    targetRelativeY: PropTypes.number,
    linkWidth: PropTypes.number,
    index: PropTypes.number
  };

  constructor(props) {
    super(props);

    const { payload } = this.props;
  }

  getIsNegative(payload) {
    return payload && payload.isNegative;
  }

  getColor() {
    const { payload } = this.props;
    return payload && payload.color
      ? payload.color
      : this.getIsNegative(payload)
        ? "url(#falseGradient)"
        : "url(#trueGradient)";
  }

  render() {
    const {
      sourceX,
      targetX,
      sourceY,
      targetY,
      sourceControlX,
      targetControlX,
      sourceRelativeY,
      targetRelativeY,
      linkWidth,
      payload,
      index
    } = this.props;

    const fillColor = this.getColor();

    return (
      <Layer key={`CustomLink${index}_${fillColor}`} className={styles.sankeyLink}>
        <path
          d={`
            M${sourceX},${sourceY + linkWidth / 2}
            C${sourceControlX},${sourceY + linkWidth / 2}
              ${targetControlX},${targetY + linkWidth / 2}
              ${targetX},${targetY + linkWidth / 2}
            L${targetX},${targetY - linkWidth / 2}
            C${targetControlX},${targetY - linkWidth / 2}
              ${sourceControlX},${sourceY - linkWidth / 2}
              ${sourceX},${sourceY - linkWidth / 2}
            Z
          `}
          fill={fillColor}
          strokeWidth="0"
        />
      </Layer>
    );
  }
}
